var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checked-box",
    transform: "translate(-1675.75 -823.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M3.5,1.25A2.25,2.25,0,0,0,1.25,3.5v13A2.25,2.25,0,0,0,3.5,18.75h13a2.25,2.25,0,0,0,2.25-2.25V3.5A2.25,2.25,0,0,0,16.5,1.25Z",
    transform: "translate(1675.25 823.25)",
    fill: "#70ad47",
    stroke: "#b5b5b5",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    "data-name": "Line 4",
    d: "M1.526,6.526,4.474,9.474l8-8",
    transform: "translate(1677.974 828.026)",
    fill: "none",
    stroke: "#fafafa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.526
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedBox);
export default __webpack_public_path__ + "static/media/checked-box.b76f5d785513d4bf7fdaceee5fd23ec0.svg";
export { ForwardRef as ReactComponent };